import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import classNames from "classnames";
import { CloseButton } from "../../components/CloseButton/CloseButton";
import { useBodyScrollLock } from "../../hooks/useBodyScrollLock";
import styles from "./Dialog.module.scss";
export const BACKGROUND_OPTIONS = {
    blurredWhite: {
        color: "rgba(255, 255, 255, 0.50)",
        blur: 5,
    },
    blurredBlack: {
        color: "rgba(0, 0, 0, 0.50)",
        blur: 5,
    },
    blurredSoftBlack: {
        color: "rgba(45, 41, 38, 0.50)",
        blur: 5,
    },
    white: {
        color: "rgba(255, 255, 255, 1)",
        blur: 0,
    },
    black: {
        color: "rgba(0, 0, 0, 1)",
        blur: 0,
    },
    softBlack: {
        color: "rgba(45, 41, 38, 1)",
        blur: 0,
    },
    transparent: {
        color: "transparent",
        blur: 5,
    },
};
export const Dialog = ({ isOpened = true, children, externalContent, theme = "light", fullscreen = false, closable = true, onClose, className = "", dialogClassName = "", closeStyle = "", dataTestId = "dialog", portalDomNode, backgroundColor = BACKGROUND_OPTIONS.transparent.color, backgroundBlur = BACKGROUND_OPTIONS.transparent.blur, noPadding = false, id, isUnwrapped, isBodyScrollDisabled, noContent = false, ariaLabelledBy, }) => {
    const [mounted, setMounted] = useState(false);
    const { toggleScroll } = useBodyScrollLock();
    useEffect(() => {
        if (!isBodyScrollDisabled) {
            toggleScroll(isOpened);
        }
        setMounted(true);
    }, [isOpened, isBodyScrollDisabled, toggleScroll, setMounted]);
    const containerStyle = {
        "--background-color": backgroundColor,
        "--backdrop-filter": `blur(${backgroundBlur}px)`,
    };
    const content = (_jsxs("div", { "data-testid": dataTestId, role: "alertdialog", "aria-modal": "true", "aria-labelledby": ariaLabelledBy, className: classNames(styles.dialogWrapper, {
            [styles.unwrapped]: isUnwrapped,
            [styles.isShown]: isOpened,
            [styles.isFullscreen]: fullscreen,
        }), children: [externalContent && _jsx("div", { className: styles.externalContent, children: externalContent }), _jsx("div", { id: id, className: classNames(styles.container, dialogClassName, {
                    ["light-theme"]: theme === "light",
                    ["dark-theme"]: theme === "dark",
                    [styles.isContainerFullscreen]: fullscreen,
                }), style: containerStyle, children: _jsxs("div", { className: classNames(styles.dialog, className, {
                        [styles.dialogDark]: theme === "dark",
                        [styles.dialogFullscreen]: fullscreen,
                        [styles.noPadding]: noPadding,
                        [styles.noContent]: noContent,
                    }), children: [_jsx("div", { className: styles.content, children: children }), closable && (_jsx(CloseButton, { dataTestId: "closeButton", onClick: onClose, className: classNames(styles.close, closeStyle) }))] }) })] }));
    // This prop should be only used for CMS authoring purposes
    if (isUnwrapped) {
        return content;
    }
    return mounted ? createPortal(content, portalDomNode || document.body) : null;
};
//# sourceMappingURL=Dialog.js.map